import { css } from '@emotion/react';
import {
  faCog,
  faFillDrip,
  faLayerGroup, faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { useTranslation } from '~/_shared/utils/hooks';
import { ActiveDataLayerContextMenuComponent } from './activeDataLayerContextMenu.component';
import { ActiveDataLayerDeleteMenuComponent } from './activeDataLayerDeleteMenu.component';

const toolbarButtonWrapperStyle = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  minHeight: 34,
  gap: 6,
});

export const ActiveDataLayerToolbarComponent = ({
  onDeleteTemplate,
  onEditFill,
  onEditLayers,
  onEditStyle,
  onExport,
  onRemove,
  onSaveAsTemplate,
}: Readonly<{
  onDeleteTemplate?: () => void;
  onEditFill: () => void;
  onEditLayers: () => void;
  onEditStyle: () => void;
  onExport?: () => void;
  onRemove: () => void;
  onSaveAsTemplate?: () => void;
}>) => {
  const [t] = useTranslation();

  return (
    <div css={toolbarButtonWrapperStyle}>
      <div>
        <RoundButtonComponent
          icon={faLayerGroup}
          onClick={onEditLayers}
          buttonStyle={RoundButtonStyle.Primary}
          size={RoundButtonSize.Small}
          tooltipLabel={t('dataLayersTool.editLayers')}
        />
      </div>
      <div>
        <RoundButtonComponent
          icon={faFillDrip}
          onClick={onEditFill}
          buttonStyle={RoundButtonStyle.Primary}
          size={RoundButtonSize.Small}
          tooltipLabel={t('Fill Settings')}
        />
      </div>
      <div>
        <RoundButtonComponent
          icon={faCog}
          onClick={onEditStyle}
          buttonStyle={RoundButtonStyle.Primary}
          size={RoundButtonSize.Small}
          tooltipLabel={t('Edit')}
        />
      </div>
      <div>
        {onDeleteTemplate ? (
          <ActiveDataLayerDeleteMenuComponent
            onDeleteTemplate={onDeleteTemplate}
            onRemove={onRemove}
          />
        ) : (
          <RoundButtonComponent
            icon={faTrash}
            onClick={onRemove}
            buttonStyle={RoundButtonStyle.Danger}
            size={RoundButtonSize.Small}
            tooltipLabel={t('Delete')}
          />
        )}
      </div>
      {(onSaveAsTemplate || onExport) && (
        <div>
          <ActiveDataLayerContextMenuComponent
            onSaveAsTemplate={onSaveAsTemplate}
            onExport={onExport}
          />
        </div>
      )}
    </div>
  );
};
